import React from "react";
import CaseInquiryToCustomer from "./CaseInquiryToCustomer";
import { useInquiry } from "../../../hooks/useInquiry";
import { ProductUnion } from "../../../types/ProductUnion";
import dayjs from "dayjs";

type CaseInquiriesToCustomerProps = {
  product: ProductUnion;
};
export default function CaseInquiriesToCustomer({ product }: CaseInquiriesToCustomerProps) {
  const { inquiryToCustomerCollection } = useInquiry(product);

  if (!inquiryToCustomerCollection || inquiryToCustomerCollection["hydra:totalItems"] === 0) {
    return null;
  }

  return (
    <>
      {inquiryToCustomerCollection["hydra:member"]
        .sort((a, b) => (dayjs(a.deadline).isAfter(dayjs(b.deadline)) ? 1 : -1))
        .map((inquiryToCustomer) => (
          <CaseInquiryToCustomer key={inquiryToCustomer.id} inquiryToCustomer={inquiryToCustomer} />
        ))}
    </>
  );
}
